import React, { Component } from 'react';
import { evaluate } from '@tencent/workbench';
import Slider from '@tencent/dui/lib/components/Slider';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { NumberInput } from '../base/number-input.js';
import formStyle from '../form-item.less.js';
import styles from './slider.less.js';
import classNames from 'classnames';

class SliderFormItem extends Component {
    constructor() {
        var _a;
        super(...arguments);
        this.value = (_a = this.props.defaultValue) !== null && _a !== void 0 ? _a : 0;
        this.handleChange = (value, allowDecimal = false, toFixed = 0, dragEnd = true, from) => {
            var _a, _b, _c, _d;
            const options = evaluate(this.props.options, {});
            if ((allowDecimal && `${value}`.endsWith('.')) || value === '' || value === (options === null || options === void 0 ? void 0 : options.suffix)) {
                this.value = value;
                if (this.value === '' || value === (options === null || options === void 0 ? void 0 : options.suffix)) {
                    (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, null, dragEnd, from);
                }
                this.forceUpdate();
                return;
            }
            let numberValue = allowDecimal ? parseFloat(`${value}`) : parseInt(`${value}`, 10);
            const base = Math.pow(10, toFixed);
            numberValue = Math.round(numberValue * base) / base;
            (_d = (_c = this.props).onChange) === null || _d === void 0 ? void 0 : _d.call(_c, numberValue, dragEnd, from);
            this.value = numberValue;
            this.forceUpdate();
        };
    }
    // eslint-disable-next-line complexity
    render() {
        var _a, _b, _c, _d;
        const { label, tooltip } = this.props;
        const tooltipText = evaluate(tooltip, null);
        const value = evaluate(this.props.value, this.value);
        const options = evaluate(this.props.options, {});
        const toFixed = (_a = options === null || options === void 0 ? void 0 : options.toFixed) !== null && _a !== void 0 ? _a : ((options === null || options === void 0 ? void 0 : options.allowDecimal) ? 2 : 0);
        const hasLabel = !!label;
        return React.createElement("div", { className: classNames(formStyle['form-item-group'], styles.slider) },
            hasLabel && React.createElement("label", { style: { height: 28 } },
                React.createElement(Tooltip, { title: tooltipText !== null && tooltipText !== void 0 ? tooltipText : label, disabled: !tooltipText && label.length < 4, style: { width: '100%' } },
                    React.createElement("span", { className: styles.clipable }, label))),
            React.createElement("div", { className: formStyle['form-item-content'] },
                React.createElement(Slider, Object.assign({ dragClassName: styles.dragger }, options, { style: { width: hasLabel ? 116 : 158, margin: hasLabel ? '0 12px' : '0 12px 0 6px' }, value: value === '' ? this.props.defaultValue : +value, onChange: v => this.handleChange(v, options.allowDecimal, toFixed, false), onChangeEnd: v => this.handleChange(v, options.allowDecimal, toFixed) }))),
            React.createElement("div", { className: formStyle['form-item-content'] },
                React.createElement(NumberInput, { min: (_b = options === null || options === void 0 ? void 0 : options.min) !== null && _b !== void 0 ? _b : 0, max: (_c = options === null || options === void 0 ? void 0 : options.max) !== null && _c !== void 0 ? _c : 100, step: (_d = options === null || options === void 0 ? void 0 : options.step) !== null && _d !== void 0 ? _d : 1, value: `${value !== null && value !== void 0 ? value : ''}`, onChange: (v, f) => this.handleChange(v, options.allowDecimal, toFixed, true, f), suffix: options === null || options === void 0 ? void 0 : options.suffix, allowDecimal: options === null || options === void 0 ? void 0 : options.allowDecimal, toFixed: toFixed, onFocus: options === null || options === void 0 ? void 0 : options.onFocus, onBlur: options === null || options === void 0 ? void 0 : options.onBlur, defaultValue: this.props.defaultValue })));
    }
}

export { SliderFormItem };
//# sourceMappingURL=slider.js.map
